import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Breeders from './tabs/Breeders'
import Cultivars from './tabs/Cultivars'

const CultivarsScreen = () => {
  const { pathname } = useLocation()
  const { routes, urlHasPermission } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        if (urlHasPermission(tab.slug, 'root')) {
          response.push(tab)
        }
      }

      addTab({
        route: '',
        slug: 'gerenciamento-de-maquinas-farm',
        title: toUpper(t('cultivar', { howMany: 2 })),
        Component: Cultivars
      })

      addTab({
        route: 'breeders',
        slug: 'gerenciamento-de-maquinas-farm',
        title: toUpper(t('breeder', { howMany: 2 })),
        Component: Breeders
      })

      return response
    },
    [t, urlHasPermission]
  )

  const crumbs = useMemo(() => [
    (pathname.includes('breeders') ? {
      title: t('breeder', { howMany: 2 }),
      key: 'breeders-screen',
      url: '/cultivars/breeders',
      active: pathname.match('/cultivars/breeders')
    } : {
      title: routes.cultivars.title,
      key: 'cultivars-screen',
      url: '/cultivars',
      active: pathname.match('/cultivars')
    })
  ], [pathname, routes.cultivars.title, t])

  return (
    <Screen title={ routes.cultivars.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default CultivarsScreen
